var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98333 0C0.754972 0 0 1.09325 0 2.12333V14.6767C0 15.7068 0.754972 16.8 1.98333 16.8H5.25V14.7H2.10135C2.10051 14.693 2.1 14.6853 2.1 14.6767V2.12333C2.1 2.11473 2.10051 2.10696 2.10135 2.1H13.9986C13.9995 2.10696 14 2.11473 14 2.12333V4.55H16.1V2.12333C16.1 1.09325 15.345 0 14.1167 0H1.98333ZM8.98333 6.3C7.84028 6.3 7 7.25773 7 8.33V21.07C7 22.1423 7.84028 23.1 8.98333 23.1H21.1167C22.2597 23.1 23.1 22.1423 23.1 21.07V8.33C23.1 7.25773 22.2597 6.3 21.1167 6.3H8.98333ZM21 21H9.1V8.4H21V21ZM18.9 12.25C18.9 12.8299 18.4299 13.3 17.85 13.3H12.25C11.6701 13.3 11.2 12.8299 11.2 12.25C11.2 11.6701 11.6701 11.2 12.25 11.2H17.85C18.4299 11.2 18.9 11.6701 18.9 12.25ZM17.85 18.2C18.4299 18.2 18.9 17.7299 18.9 17.15C18.9 16.5701 18.4299 16.1 17.85 16.1H12.25C11.6701 16.1 11.2 16.5701 11.2 17.15C11.2 17.7299 11.6701 18.2 12.25 18.2H17.85Z",
    fill: "#8D9299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.aa12f5e5611c53566c238ae128ea8146.svg";
export { ForwardRef as ReactComponent };